import {PageLink} from '../../_metronic/layout/core'
import Navigation from '../../components/Navigation/Navigation'
import OrderAuditList from './layouts/OrderAuditList'

const OrderAuditBreadCrumbs: Array<PageLink> = [
  {
    title: 'Orders',
    path: '/orders/all-orders',
    isSeparator: false,
    isActive: false,
  },
]

const OrderAuditPage = () => {
  return (
    <Navigation
      baseUrl='/orders/order-price-report'
      breadcrumbs={OrderAuditBreadCrumbs}
      defaultKey='active'
      disableSearchParams={false}
      viewSingleComponent={true}
      navigationData={[
        {
          key: 'active',
          label: 'Active',
          component: <OrderAuditList />,
          title: 'Order Price Report',
        },
        {
          key: 'archived',
          label: 'Archived',
          component: <OrderAuditList />,
          title: 'Order Price Report',
        },
      ]}
    />
  )
}

export default OrderAuditPage
